export default {
  meta: {
    title: '商圈决策报告',
    url: '/share/mallreport',
    urlName: '商圈决策报告',
  },
};
